import getUnlinkedVoipaccounts from '@/lib/data/getUnlinkedVoipaccounts.mjs';

import sortColltacts from '@/utils/sortColltacts.ts';

export function all(forceRefresh = false) {
  return getUnlinkedVoipaccounts(forceRefresh).then((voipaccounts) => voipaccounts.sort(sortColltacts));
}
